// thinking maybe we want a config for anything that doesn't change
export default function useEnableRecaptcha() {
  return global.__AT_DATA__.enableRecaptcha;
}
